import Vue from 'vue';
import MainFrame from '@/layouts/default.vue';
import ErrorFrame from '@/layouts/error.vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueAxios from 'vue-axios';
import axios from 'axios';
import _ from 'lodash';
import ElementUI from 'element-ui';
import VueAppend from 'vue-append';
import i18n from '@/plugins/i18n';
import App from './App.vue';
import router from './router';
import '@/plugins/jquery';
import '@/assets/scss/element-variables.scss';

// Bus
import './bus';
// Filters
import './lib/Filters';

Vue.config.productionTip = false;
Vue.component('mainframe', MainFrame);
Vue.component('errorFrame', ErrorFrame);

Vue.use(VueMoment, { moment });
// 套件加入到Vue的藍圖內(原型內)
Vue.use(VueAxios, axios);
Vue.use(VueAppend);
// 使用 Element UI 並配置 i18n
// Element UI 內建支援多種語系（如英文、中文、日文、韓文等），可在 element-ui/lib/locale/lang/ 下找到。
// 你也可以自己定義語系，只需依照格式建立一個語言包，然後在 i18n 設定中引用即可。
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

Vue.prototype._ = _;
Vue.prototype.$msgbox = ElementUI.MessageBox;
Vue.prototype.$alert = ElementUI.MessageBox.alert;
Vue.prototype.$confirm = ElementUI.MessageBox.confirm;
Vue.prototype.$prompt = ElementUI.MessageBox.prompt;
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$UserId = '';
Vue.prototype.$UserAccount = '';
Vue.prototype.$UserName = '';
Vue.prototype.$IsBinding = '';
Vue.prototype.$DEV = process.env.VUE_APP_DEV;
Vue.prototype.$MAINTAIN = process.env.VUE_APP_MAINTAIN;
// Vue.prototype.$source = '';

Vue.prototype.$setUserAccount = () => {
  const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');
  Vue.prototype.$UserAccount = '';
  if (token) {
    const jsonObj = JSON.parse(
      decodeURIComponent(
        escape(
          window.atob(
            token
              .split('.')[1]
              .replace(/-/g, '+')
              .replace(/_/g, '/'),
          ),
        ),
      ),
    );
    Vue.prototype.$UserId = jsonObj.UserId;
    Vue.prototype.$UserAccount = jsonObj.UserAccount;
    Vue.prototype.$UserName = jsonObj.UserName;
    Vue.prototype.$IsBinding = jsonObj.IsBinding;
  }
  Vue.prototype.$bus.$emit('setUserAccount', Vue.prototype.$UserAccount);
};

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
